var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header",style:(_vm.backgroundStyle)},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }